import React from "react";
import blogd1 from "../assets/images/medical_article/medical.jpg";
import author1 from "../assets/images/medical_logo/niming.jpg";
import lp1 from"../assets/images/medical_article/medical.jpg";
import lp2 from "../assets/images/medical_article/medical.jpg";
import lp3 from"../assets/images/medical_article/medical.jpg";
import article from "../assets/images/article/4.jpg"
const ArticleDetails = () => {
  return (
    <section className="blog-details">
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <div className="blog-one__single">
              <div className="blog-one__image">
                <img src={blogd1} alt="" />
              </div>
              <div className="blog-one__content text-center">
                <div className="blog-one__meta">
                  <a
                    data-toggle="tooltip"
                    data-placement="top"
                    title=""
                    href="#none"
                    data-original-title="Posted On Jan 19"
                  >
                    <i className="fa fa-calendar-alt"></i>
                  </a>
                  <a
                    data-toggle="tooltip"
                    data-placement="top"
                    title=""
                    href="#none"
                    data-original-title="No Comments"
                  >
                    <i className="fa fa-comments"></i>
                  </a>
                  <a
                    data-toggle="tooltip"
                    data-placement="top"
                    title=""
                    href="#none"
                    data-original-title="Posted By Admin"
                  >
                    <i className="fa fa-user"></i>
                  </a>
                </div>
                <h2 className="blog-one__title">
                医院静脉用药调配中心的自动化系统建设与实践
                </h2>
<img src={article} alt="" style={{width:"100%"}}></img>
              </div>
            </div>
            <div className="share-block">
              
           </div>
            <div className="blog-details__author">
              <div className="blog-details__author-image">
                <img src={author1} alt="Awesome alter text" />
              </div>
              <div className="blog-details__author-content">
                <h3>匿名</h3>
                <p></p>
              </div>
            </div>
         </div>
          <div className="col-lg-4">
            <div className="sidebar">
            <div className="sidebar__single sidebar__post">
  <h3 className="sidebar__title">阅读推荐</h3>
  <div className="sidebar__post-wrap">
    <div className="sidebar__post__single">
      <div className="sidebar__post-image">
        <div className="inner-block">
          <img src={lp1} alt="Awesome alter text" />
        </div>
      </div>
      <div className="sidebar__post-content">
        <h4 className="sidebar__post-title">
          <a href="#none">
          智能分拣系统在我院PIVAS中的应用
          </a>
        </h4>
      </div>
    </div>
    <div className="sidebar__post__single">
      <div className="sidebar__post-image">
        <div className="inner-block">
          <img src={lp2} alt="Awesome alter text" />
        </div>
      </div>
      <div className="sidebar__post-content">
        <h4 className="sidebar__post-title">
          <a href="#none">
          医院静脉用药调配中心的自动化系统建设与实践
          </a>
        </h4>
      </div>
    </div>
    <div className="sidebar__post__single">
      <div className="sidebar__post-image">
        <div className="inner-block">
          <img src={lp3} alt="Awesome alter text" />
        </div>
      </div>
      <div className="sidebar__post-content">
        <h4 className="sidebar__post-title">
          <a href="#none">
          智能标签打印系统在医院静脉用药集中调配中心的应用
          </a>
        </h4>
      </div>
    </div>
  </div>
</div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ArticleDetails;
